let hiddenTextarea;

const HIDDEN_STYLE = `
  height:0 !important;
  visibility:hidden !important;
  overflow:scroll !important;
  position:absolute !important;
  z-index:-1000 !important;
  top:0 !important;
  right:0 !important;
`;

const CONTEXT_STYLE = [
    'letter-spacing',
    'line-height',
    'padding-top',
    'padding-bottom',
    'font-family',
    'font-weight',
    'font-size',
    'text-rendering',
    'text-transform',
    'width',
    'text-indent',
    'padding-left',
    'padding-right',
    'border-width',
    'box-sizing',
];

function calculateNodeStyling(targetElement) {
    const style = window.getComputedStyle(targetElement);

    const paddingSize = (
        parseFloat(style.getPropertyValue('padding-bottom')) +
        parseFloat(style.getPropertyValue('padding-top'))
    );

    const borderSize = (
        parseFloat(style.getPropertyValue('border-bottom-width')) +
        parseFloat(style.getPropertyValue('border-top-width'))
    );

    const contextStyle = CONTEXT_STYLE
        .map((name) => `${name}:${style.getPropertyValue(name)}`)
        .join(';');

    return {
        contextStyle, paddingSize, borderSize,
    };
}

export default function calcTextareaHeight(
    targetElement,
    minRows = 2,
    maxRows = null,
) {
    hiddenTextarea = document.createElement('textarea');
    document.body.appendChild(hiddenTextarea);

    const { paddingSize,
        borderSize,
        contextStyle } = calculateNodeStyling(targetElement);

    hiddenTextarea.setAttribute('style', `${contextStyle};${HIDDEN_STYLE}`);
    hiddenTextarea.value = targetElement.value || targetElement.placeholder || '';

    let height = hiddenTextarea.scrollHeight;
    const result = {};
    height += borderSize;

    hiddenTextarea.value = '';
    const singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;

    if (minRows !== null) {
        let minHeight = singleRowHeight * minRows;
        minHeight = minHeight + paddingSize + borderSize;
        height = Math.max(minHeight, height);
        result.minHeight = `${minHeight}px`;
    }
    if (maxRows !== null) {
        let maxHeight = singleRowHeight * maxRows;
        maxHeight = maxHeight + paddingSize + borderSize;
        height = Math.min(maxHeight, height);
    }
    result.height = `${height}px`;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    hiddenTextarea.parentNode && hiddenTextarea.parentNode.removeChild(hiddenTextarea);
    hiddenTextarea = null;
    return result;
}
